<div *ngIf="billingList.length > 0" class="w-100">
  <a id="billcostbreaddownheader" class="mapfre link collapse-link active" (click)="toggleBillingCost()" mdbRipple>
    <div class="row ml-0 mr-0 align-items-center cov-innr-pt-pb" id="billcostbreakdownCommon"
      [ngClass]="{'no-padding':policy?.policynumber?.policyNumber.length === 6}">
      <div class="col require-cov-block">
        <div class="row">
          <span class="fs-16 bn-breakdown-status" id="breakdownstatus">
            Hide billing schedule
          </span>
        </div>
      </div>
      <div class="col collapse-carot cost-breakdown  text-right pl-0 pr-2" *ngIf="!isAcmic">
        <img class="fas fa-caret-down" src="assets/img/images/icon-simple-arrow-down-red.svg" alt="down arrow" />
        <img class="fas fa-caret-up" src="assets/img/images/icon-simple-arrow-up-red.svg" alt="up arrow" />
      </div>
      <div class="col collapse-carot cost-breakdown text-right pl-0 pr-2" *ngIf="isAcmic">
        <img class="fas fa-caret-down" src="assets/img/images/down-icon-acmic.svg" alt="down arrow" />
        <img class="fas fa-caret-up" src="assets/img/images/up-icon-acmic.svg" alt="up arrow" />
      </div>
    </div>
  </a>
  <div class="bn-breakdown-title-header" id="billcostbreakdowntitle">
    <div id="bntitle" class="margin-top mt24"
      *ngIf="policy?.paymentPlan && policy?.paymentPlan !== 'N/A' && isAcmic">
      <div class="bn-title-text mb-2">{{ 'PAYMENT_PLAN' | translate }}</div>
      <div class="bn-title-val">{{ policy?.paymentPlan?.replace('MAIP','') }}</div>
    </div>
    <div id="bntitle" class="margin-top mt24" *ngIf="policy?.policynumber?.policyNumber.length === 6">
      <div class="bn-title-val">Billing schedule</div>
    </div>
  </div>

  <div class="billing-schedule" id="billcostbreakdown" [ngClass]="{'pt-3': !isAcmic}">
    <div class="grid-container" [ngClass]="{'mb-4': !isAcmic}">
      <div *ngFor="let bill of billingList" class="billing-card" [ngClass]="bill.status">
        <ng-container *ngIf="!policy?.isUnderRenewal">
          <div class="date-label" *ngIf="!isAcmic" [ngStyle]="{ 
          color: bill.status === 'current' ? '#008C47' : '#2D373D',
          backgroundColor: bill.status === 'current' ? '#F7F9F0' : '#F5F6F7'}">
            {{ bill.status === 'current' ? 'Current month' : 'Upcoming' }}
          </div>
          <div class="date-label" *ngIf="isAcmic" [ngStyle]="{ 
          color: bill.status === 'current' ? '#388E3D' : '#363636',
          backgroundColor: bill.status === 'current' ? '#F7F9F0' : '#F6F6F6'}">
            {{ bill.status === 'current' ? 'Current month' : 'Upcoming' }}
          </div>
          <div class="billing-date">{{bill.date | date: 'MM/dd/yyyy'}}</div>
          <div class="billing-amount">{{bill.amount}}</div>
        </ng-container>
        <ng-container *ngIf="policy?.isUnderRenewal">
          <div class="date-label" *ngIf="!isAcmic" [ngStyle]="{ 
          color: bill.status === 'current' ? '#008C47' : '#0D82BD',
          backgroundColor: bill.status === 'current' ? '#F7F9F0' : '#EEF6FB'}">
            {{ bill.status === 'current' ? 'Current month' : 'Renewal' }}
          </div>
          <div class="date-label" *ngIf="isAcmic" [ngStyle]="{ 
          color: bill.status === 'current' ? '#388E3D' : '#0078D6',
          backgroundColor: bill.status === 'current' ? '#F7F9F0' : '#EEF6FB'}">
            {{ bill.status === 'current' ? 'Current month' : 'Renewal' }}
          </div>
          <div class="billing-date">{{bill.date | date: 'MM/dd/yyyy'}}</div>
          <div class="billing-amount">{{bill.amount}}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="hr-2 thin-hr" [ngClass]="{'margin-top mt32':policy?.policynumber?.policyNumber.length === 6}">
</div>
